import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import { Provider } from 'mobx-react'
import React from 'react'
import * as ReactDOM from 'react-dom'
import { BrowserRouter, NavigateFunction, useNavigate } from 'react-router-dom'
import { SnackbarProvider, CookieBanner } from './components'
import { theme } from './config'
import './fonts/fonts.css'
import './i18n'
import { Routes } from 'routes'
import { AuthStore, RootStore, RoutingStore } from 'stores'


export const routingStore = new RoutingStore();
export const authStore    = new AuthStore(routingStore);
export const rootStore    = new RootStore(authStore);

const stores = {
  authStore:    authStore,
  rootStore:    rootStore,
  routingStore: rootStore.routingStore,
}

const App = () => {
  return (
    <Provider {...stores}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <GlobalStyles styles={{ html: { fontSize: '62.5%' } }} />
          <CssBaseline />
          <SnackbarProvider>
            <Routes />
          </SnackbarProvider>
          <CookieBanner />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  )
}

ReactDOM.render(<App />, document.getElementById('root'));
